export default "__VITE_ASSET__BUff75_D__"